import { createSelector } from '@ngrx/store';

import { FeasibilityEstimate } from '@ps/survey-utils';

import { surveyCreationFeature } from '../survey-creation.feature';
import { selectActiveInsightsChild } from './utils/insights-children.helper';

const { selectInsights } = surveyCreationFeature;

const selectActiveChild = createSelector(
  selectInsights,
  selectActiveInsightsChild,
);

/** Every child, not just the active one — for work that runs per locale. */
export const selectInsightsChildren = createSelector(
  selectInsights,
  ({ children }) => children,
);

//SECTION SCORE
export const selectScorePercentage = createSelector(
  selectActiveChild,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectActiveChild,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectActiveChild,
  ({ score }) => score.error,
);
//!SECTION

//SECTION FEASIBILITY
export const selectFeasibilityLoading = createSelector(
  selectActiveChild,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectActiveChild,
  ({ feasibility }) => feasibility.error,
);

export const selectFeasibility = createSelector(
  selectActiveChild,
  ({ feasibility }): FeasibilityEstimate => ({
    total: feasibility.total,
    audience: feasibility.audience,
    quotaGroups: feasibility.quotaGroups,
    cpi: feasibility.cpi,
    suppliers: feasibility.suppliers,
  }),
);

export const selectAdvancedFiltersLookup = createSelector(
  selectActiveChild,
  ({ feasibility }) => feasibility.advancedFiltersLookup,
);

export const selectFeasibilityCpi = createSelector(
  selectActiveChild,
  ({ feasibility }) => feasibility.cpi,
);

export const selectFeasibilitySuppliers = createSelector(
  selectActiveChild,
  ({ feasibility }) => feasibility.suppliers,
);
//!SECTION

//SECTION FLEXIBILITY PRICES
export const selectFlexibilityPrices = createSelector(
  selectActiveChild,
  ({ flexibilityPrices }) => flexibilityPrices.prices,
);

export const selectFlexibilityPricesError = createSelector(
  selectActiveChild,
  ({ flexibilityPrices }) => flexibilityPrices.error,
);
//!SECTION

//SECTION PRICING
export const selectPricing = createSelector(
  selectActiveChild,
  ({ pricing }) => pricing,
);
//!SECTION

//SECTION SIMILAR SURVEYS
export const selectSimilarSurveysState = createSelector(
  selectActiveChild,
  ({ similarSurveys }) => similarSurveys,
);

export const selectSimilarSurveys = createSelector(
  selectSimilarSurveysState,
  ({ surveys }) => surveys,
);

export const selectSimilarSurveysStatus = createSelector(
  selectSimilarSurveysState,
  ({ status }) => status,
);

export const selectSimilarSurveysError = createSelector(
  selectSimilarSurveysState,
  ({ error }) => error,
);

export const selectSimilarSurveysStale = createSelector(
  selectSimilarSurveysState,
  ({ isStale }) => isStale,
);

export const selectSimilarSurveysSearchedTargetingKey = createSelector(
  selectSimilarSurveysState,
  ({ searchedTargetingKey }) => searchedTargetingKey,
);

export const selectSimilarSurveysHasSearched = createSelector(
  selectSimilarSurveysSearchedTargetingKey,
  (searchedTargetingKey) => !!searchedTargetingKey,
);

export const selectSimilarSurveysSearchedGlobally = createSelector(
  selectSimilarSurveysState,
  ({ searchedGlobally }) => searchedGlobally,
);

export const selectSimilarSurveysGlobalSearchUsed = createSelector(
  selectSimilarSurveysState,
  ({ globalSearchUsed }) => globalSearchUsed,
);
//!SECTION
